module.exports = __webpack_public_path__ + "0b4aa7e9996abcdcff9cebc00362fb45.pdf";